import React, { useCallback, useMemo, useState } from 'react';
import { getFilteredInfoCb } from './lib/data';
import {
  FlatsTableListContext,
  FlatsTableListActionsContext,
} from './contexts';
import { useDispatch } from 'react-redux';
import { setSelectedFlats } from '../../../../store/actions/housingStockActions';

const Provider = ({ children }) => {
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});

  const dispatch = useDispatch();

  const onClearSelectedFlats = useCallback(() => {
    dispatch(setSelectedFlats([]));
  }, [dispatch]);

  const handleTableChange = useCallback(({ entranceName, filters, sorter }) => {
    setFilteredInfo(
      getFilteredInfoCb({ entranceName, filters, onClearSelectedFlats })
    );
    setSortedInfo(sorter);
  }, []);

  const state = useMemo(
    () => ({ filteredInfo, sortedInfo }),
    [filteredInfo, sortedInfo]
  );

  const actions = useMemo(
    () => ({ onTableChange: handleTableChange }),
    [handleTableChange]
  );

  return (
    <FlatsTableListContext.Provider value={state}>
      <FlatsTableListActionsContext.Provider value={actions}>
        {children}
      </FlatsTableListActionsContext.Provider>
    </FlatsTableListContext.Provider>
  );
};

export default Provider;
